import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useAudioContext } from '../../context/AudioContext';
import { useNavigationContext } from '../../context/NavigationContext';
import jokeVideo from '../../assets/videos/FraunhoferJoke-EN.mp4';
import jokeVideoDe from '../../assets/videos/FraunhoferJoke-DE.mp4';

import { useTranslation } from 'react-i18next';
import { SectionIDs } from '../../data/Sections';

import styles from './styles.module.scss';

const TheJokeVideo = React.forwardRef((props, ref) =>
{
  const { i18n } = useTranslation('ai4Jokes');
  const { globalMuted } = useAudioContext();
  const { activeSectionID } = useNavigationContext();

  const isVisible = useMemo(() => activeSectionID === SectionIDs.Joke,[activeSectionID]);

  const source = useMemo(()=> i18n.language === 'en' ? jokeVideo : jokeVideoDe, [i18n.language]);

  const onClick = () => {
    // @ts-expect-error fu ts
    ref?.current.play();
  };

  const onPlay = () => {
    console.log('Video started playing');
  };

  useEffect(()=>{
    // @ts-expect-error fu ts
    const video = ref?.current;
    if(!video) return;

    if(isVisible) {
      const canPlay = video.play();

      // Catch video not being able to play
      // This can happen when loading the app on the "theJoke" page
      if (canPlay !== undefined) {
        canPlay.catch(() => {
          console.log('Video couldn\'t be played');
          // Show the placeholder again
          video.load();
        }).then(() => {
          console.log('Video played successfully');
        });
      }
    } else {
      video.pause();
      video.currentTime = 0;
    }
  }, [isVisible]);

  useEffect(() => {    
    // @ts-expect-error fu ts
    const video = ref?.current;
    if(!video) return;
    video.load();
  }, [source]);

  return (
    <div className={styles.videoContainer} data-visible={isVisible}>
      <video 
        //   @ts-expect-error FU ts
        ref={ref} 
        preload={'auto'}
        playsInline={true} 
        muted={globalMuted}
        poster={'assets/images/video-poster.jpg'}
        onClick={onClick}
        onPlay={onPlay}
      >
        <source src={source} type={'video/mp4'} />
      </video>
    </div>
  );
});

TheJokeVideo.displayName = 'TheJokeVideo';

export default TheJokeVideo;